import { render, staticRenderFns } from "./CopyStakeAiStreamerJobDetails.vue?vue&type=template&id=3345cb24&scoped=true&lang=pug"
import script from "./CopyStakeAiStreamerJobDetails.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAiStreamerJobDetails.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeAiStreamerJobDetails.vue?vue&type=style&index=0&id=3345cb24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3345cb24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VContainer,VIcon,VRow})
